import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { Destroyable } from '../../utils/mixins/destroyable.mixin';

import {
  PASSWORD_MIN_LENGTH,
  FOOTER_TEXT,
  EMAIL_REGEX,
  PASSWORD_REGEX,
} from '../../core/consts/consts';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { AUTH_PROVIDER_TOKEN, AuthProvider } from '../../core/tokens/auth-provider.token';

@Component({
  selector: 'app-welcome-page',
  imports: [
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule
],
  standalone: true,
  templateUrl: './welcome-page.component.html',
  styleUrl: './welcome-page.component.scss',
})
export class WelcomePageComponent extends Destroyable(Object) implements OnInit {
  readonly footerText = FOOTER_TEXT;

  @Input() buttonLabel = '';
  @Input() enforcePasswordPolicy = false;
  @Input() pageName = '';
  @Input() showPasswordField = true;
  @Output() buttonClicked = new EventEmitter<[string, string | null]>();

  emailAddress = new FormControl('', [Validators.required, Validators.pattern(EMAIL_REGEX)]);
  password = new FormControl('', [Validators.required]);

  hidePassword = true;

  /** True for redirect-based auth providers (Okta, Msal) – hides the login form. */
  get isRedirectAuth(): boolean {
    return this.authProvider !== 'Api';
  }

  constructor(
    @Inject(AUTH_PROVIDER_TOKEN) private authProvider: AuthProvider,
    private changeDetectorRef: ChangeDetectorRef,
  ) {
    super();
  }

  ngOnInit(): void {
    this.initializeButtonLabel();
    this.initializePasswordValidators();
    this.changeDetectorRef.detectChanges();
  }

  getEmailAddressErrorMessage(): string {
    if (this.emailAddress.hasError('required')) {
      return 'You must enter a value';
    }

    return this.emailAddress.hasError('pattern') ? 'Not a valid email' : '';
  }

  getPasswordErrorMessage(): string {
    if (this.password.hasError('required')) {
      return 'You must enter a value';
    }

    return '';
  }

  onButtonClick(): void {
    this.buttonClicked.emit([
      this.emailAddress.value ?? '',
      this.showPasswordField ? this.password.value : null,
    ]);
  }

  enterSubmit(event: any): void {
    if (event.keyCode === 13) this.onButtonClick();
  }

  private initializeButtonLabel(): void {
    if (!this.buttonLabel && this.pageName) {
      this.buttonLabel = this.pageName;
    }
  }

  private initializePasswordValidators(): void {
    if (this.enforcePasswordPolicy) {
      this.password.addValidators([
        Validators.minLength(PASSWORD_MIN_LENGTH),
        Validators.pattern(PASSWORD_REGEX),
      ]);
    }
  }
}
